const backendErrors = new Map()
const campaignsMessages = new Map()

backendErrors.set("ERR_NO_OTHER_WHATSAPP", "Deve haver pelo menos um WhatsApp padrão.")
backendErrors.set("ERR_NO_DEF_WAPP_FOUND", "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.")
backendErrors.set(
  "ERR_WAPP_NOT_INITIALIZED",
  "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
)
backendErrors.set(
  "ERR_WAPP_CHECK_CONTACT",
  "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
)
backendErrors.set("ERR_WAPP_INVALID_CONTACT", "Este não é um número de Whatsapp válido.")
backendErrors.set(
  "ERR_WAPP_DOWNLOAD_MEDIA",
  "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
)
backendErrors.set("ERR_INVALID_CREDENTIALS", "Erro de autenticação. Por favor, tente novamente.")
backendErrors.set("ERR_SENDING_WAPP_MSG", "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.")
backendErrors.set("ERR_DELETE_WAPP_MSG", "Não foi possível eliminar a mensagem do WhatsApp.")
backendErrors.set("ERR_OTHER_OPEN_TICKET", "Já existe uma conversa aberta para este contato.")
backendErrors.set("ERR_SESSION_EXPIRED", "Sessão expirada. Por favor entre.")
backendErrors.set("ERR_USER_CREATION_DISABLED", "A criação do usuário foi desabilitada pelo administrador.")
backendErrors.set("ERR_NO_PERMISSION", "Você não tem permissão para acessar este recurso.")
backendErrors.set("ERR_DUPLICATED_CONTACT", "Já existe um contato com este número.")
backendErrors.set("ERR_NO_SETTING_FOUND", "Nenhuma configuração encontrada com este ID.")
backendErrors.set("ERR_NO_CONTACT_FOUND", "Nenhum contato encontrado com este ID.")
backendErrors.set("ERR_NO_TICKET_FOUND", "Nenhuma conversa encontrada com este ID.")
backendErrors.set("ERR_NO_USER_FOUND", "Nenhum usuário encontrado com este ID.")
backendErrors.set("ERR_NO_WAPP_FOUND", "Nenhum WhatsApp encontrado com este ID.")
backendErrors.set("ERR_CREATING_MESSAGE", "Erro ao criar mensagem no banco de dados.")
backendErrors.set("ERR_CREATING_TICKET", "Erro ao criar conversa no banco de dados.")
backendErrors.set("ERR_FETCH_WAPP_MSG", "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.")
backendErrors.set("ERR_QUEUE_COLOR_ALREADY_EXISTS", "Esta cor já está em uso, escolha outra.")
backendErrors.set("ERR_WAPP_GREETING_REQUIRED", "A mensagem de saudação é obrigatório quando há mais de uma fila.")
backendErrors.set("ERR_SET_TIMEZONE", "Erro ao carregar fuso horário.")

campaignsMessages.set("name", "Nome")
campaignsMessages.set("message1", "Mensagem 1")
campaignsMessages.set("message2", "Mensagem 2")
campaignsMessages.set("message3", "Mensagem 3")
campaignsMessages.set("message4", "Mensagem 4")
campaignsMessages.set("message5", "Mensagem 5")
campaignsMessages.set("confirmationMessage1", "Mensagem de Confirmação 1")
campaignsMessages.set("confirmationMessage2", "Mensagem de Confirmação 2")
campaignsMessages.set("confirmationMessage3", "Mensagem de Confirmação 3")
campaignsMessages.set("confirmationMessage4", "Mensagem de Confirmação 4")
campaignsMessages.set("confirmationMessage5", "Mensagem de Confirmação 5")
campaignsMessages.set("messagePlaceholder", "Conteúdo da mensagem")
campaignsMessages.set("whatsapp", "Conexão")
campaignsMessages.set("status", "Status")
campaignsMessages.set("scheduledAt", "Agendamento")
campaignsMessages.set("confirmation", "Confirmação")
campaignsMessages.set("contactList", "Lista de Contato")
campaignsMessages.set("situacaoList", "Lista de Situações")
campaignsMessages.set("fileList", "Lista de Arquivos")

const returnBackendError = (message) => {
  return backendErrors.get(message)
}

const returnCampaigns = (message) => {
  return campaignsMessages.get(message)
}

export { returnBackendError, returnCampaigns }
